<template>
    <div>
        <div class="main-content">
            <div class="page-content">
            <div class="container">
                <div class="page-links" >
                    <router-link to="/climbing/camps" class="page-links__item">Camps & Heights</router-link>
                    <router-link to="/climbing/distance" class="page-links__item">Distance & Time</router-link>
                    <router-link to="/climbing/temperature" class="page-links__item">Temperature</router-link>
                    <router-link to="/climbing/moon" class="page-links__item is-active">Moon Phases</router-link>
                </div>
                <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
                <section class="kilimanjaro-table" v-if="isLoad">
                <div class="page-title">
                    <h2>Moon Phases</h2>
                </div>
                <div class="kilimanjaro-table__top" v-if="isLoad">
                    <div class="kilimanjaro-table__top__side"><span class="kilimanjaro-table__top__label">Showing moon phases for:</span>
                    <div class="form-control-group">
                        <div :class="['select-wrapper', 'select-wrapper--sm', { 'is-active' : year }]" @click="year = !year">
                        <div class="select-trigger select-trigger-moon"><span class="select-trigger__name">{{years.find(item => item.active).name}}</span><span class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                        <div class="select-body">
                            <simplebar>
                                <div
                                    v-for="item in years"
                                    :key="item.name"
                                    :class="['select-option', { 'is-selected' : item.active }]"
                                    @click="years = years.map(i => i.name === item.name ? { ...i, active: true } : { ...i, active: false })"
                                    ><span class="select-option__name">{{item.name}}</span></div>
                            </simplebar>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <form action="javascript:void(0)" class="kilimanjaro-table__form" v-if="isLoad">
                    <div data-simplebar="data-simplebar" class="section-table-wrap">
                    <table class="kilimanjaro-table__item kilimanjaro-table__item--moon">
                        <thead>
                        <tr>
                            <th class="kilimanjaro-table__item__lunation"><span>Lunation</span></th>
                            <th class="kilimanjaro-table__item__descr">
                            <svg width="1em" height="1em" class="icon icon-newmoon ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-newmoon"></use>
                            </svg><span>New Moon</span>
                            </th>
                            <th class="kilimanjaro-table__item__time"><span>Time</span></th>
                            <th class="kilimanjaro-table__item__descr">
                            <svg width="1em" height="1em" class="icon icon-firstquater ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-firstquater"></use>
                            </svg><span>First Quater</span>
                            </th>
                            <th class="kilimanjaro-table__item__time"><span>Time</span></th>
                            <th class="kilimanjaro-table__item__descr">
                            <svg width="1em" height="1em" class="icon icon-fullmoon ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fullmoon"></use>
                            </svg><span>Full Moon</span>
                            </th>
                            <th class="kilimanjaro-table__item__time"><span>Time</span></th>
                            <th class="kilimanjaro-table__item__descr">
                            <svg width="1em" height="1em" class="icon icon-thirdquater ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-thirdquater"></use>
                            </svg><span>Third Quarter</span>
                            </th>
                            <th class="kilimanjaro-table__item__time"><span>Time</span></th>
                            <th class="kilimanjaro-table__item__duration"><span>Duration</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in moon" :key="item.lunation">
                            <td class="kilimanjaro-table__item__lunation"><span>{{item.lunation}}</span></td>
                            <td class="kilimanjaro-table__item__descr"><span>{{item.newMoonDate}}</span></td>
                            <td class="kilimanjaro-table__item__time"><span>{{item.newMoonTime}}</span></td>
                            <td class="kilimanjaro-table__item__descr"><span>{{item.firstQuarterMoonDate}}</span></td>
                            <td class="kilimanjaro-table__item__time"><span>{{item.firstQuarterMoonTime}}</span></td>
                            <td class="kilimanjaro-table__item__descr"><span>{{item.fullMoonDate}}</span></td>
                            <td class="kilimanjaro-table__item__time"><span>{{item.fullMoonTime}}</span></td>
                            <td class="kilimanjaro-table__item__descr"><span>{{item.thirdQuarterMoonDate}}</span></td>
                            <td class="kilimanjaro-table__item__time"><span>{{item.thirdQuarterMoonTime}}</span></td>
                            <td class="kilimanjaro-table__item__duration"><span>{{item.duration}}</span></td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </form>
                </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import simplebar from 'simplebar-vue';

    import { 
        getMoon
    } from '@/utilites/api'

    export default {
        data(){
            return { 
                moon: [],
                years: [
                    {
                        name: 2021,
                        active: true
                    },
                    {
                        name: 2022,
                        active: false
                    },
                    {
                        name: 2023,
                        active: false
                    },
                    {
                        name: 2024,
                        active: false
                    },
                    {
                        name: 2025,
                        active: false
                    },
                    {
                        name: 2026,
                        active: false
                    },
                    {
                        name: 2027,
                        active: false
                    },
                    {
                        name: 2028,
                        active: false
                    },
                    {
                        name: 2029,
                        active: false
                    },
                    {
                        name: 2030,
                        active: false
                    },
                ],
                year: false,
                isLoad: false
            }
        },
        components: { simplebar },
        props: ['user'],
        beforeCreate(){
            document.title = 'Climbing / Moon Phases'
        },
        mounted(){
            this.updateData()
            document.title = 'Climbing / Moon Phases'
            window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.year = false
                }
            })
        },
        methods: {
            updateData(){
                this.isLoad = false
                getMoon(this.user.access_token, this.years.find(item => item.active).name)
                .then(res => {
                    this.moon = res
                    this.isLoad = true
                })
            },
        },
        watch: {
            years(){
                this.updateData()
            }
        }
    }

</script>